<template>
  <div class="dz-preview dz-file-preview uploadPreview">
    <div class="uploadedPart">
      <div class="uploadedPart__thumbnail">
        <i class="fas fa-circle-notch fa-spin uploadedPart__thumbnailSpinner"></i>
      </div>

      <div class="dz-details uploadedPart__content">
        <div class="uploadedPart__contentHeading">
          <div class="dz-filename uploadedPart__filename"><span data-dz-name></span></div>
          <div class="dz-size uploadedPart__filesize">(<span data-dz-size></span>)</div>
        </div>
        <div class="uploadedPart__contentDescription">
          <div class="uploadPreview__errorMessage dz-error-message"></div>
        </div>
      </div>

      <div class="uploadPreview__status status">
        <div class="uploadPreview__successIcon dz-success-mark">
          <i class="fas fa-check"></i>
        </div>
        <div class="uploadPreview__errorIcon dz-error-mark">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>

    <div class="dz-progress uploadPreview__progress">
      <div class="dz-upload uploadPreview__progressBar" data-dz-uploadprogress></div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
